import { addDays, addHours } from '../../helpers/date'
import UpToAndIncludingDate from '../../helpers/date/UpToAndIncludingDate'
import UpToButExcludingDate from '../../helpers/date/UpToButExcludingDate'
import getStartOfWeek from './getStartOfWeek'

export default function getEndOfWeek(date: Date, hourCorrection = 0): UpToAndIncludingDate {
    const endDate = addHours(addDays(getStartOfWeek(date), 7), hourCorrection)
    return new UpToButExcludingDate(endDate).transformToUpToAndIncludingDate()
}
